import { defineStore } from 'pinia';
import constants from '@/utils/constants.js';
import { useInstitutionStore } from '@/stores/institution';
import api from '@/api';
import { ProfileFragment } from '@/graphql/custom-types';
import { Profile_Type } from '@/graphql/generated-schema-types';

interface IProfilesState {
  all: ProfileFragment[];
  myArchive: any;
  pinValidation: any;
}

export const useProfilesStore = defineStore('profiles', {
  state: (): IProfilesState => ({
    all: [],
    myArchive: {},
    pinValidation: {},
  }),
  actions: {
    async getProfiles() {
      const institutionStore = useInstitutionStore();

      const departmentIds = (institutionStore.departments || []).map(
        (department) => department.id
      );

      try {
        const rawProfiles = await api.profiles.getProfiles(departmentIds);
        const profiles = rawProfiles.map((profile) => {
          if (!profile.showImage) {
            profile.displayImage = constants.avatarPlaceholder;
          }
          return profile;
        });

        this.all = profiles;
      } catch (error) {
        console.log('Error getting profiles', error);
      }
    },
    async getMyArchive({ id, type }: { id: string; type: Profile_Type }) {
      try {
        const archive = await api.archive.getMyArchive({
          profileType: type,
          profileId: id,
        });
        this.myArchive = archive;
      } catch (error) {
        console.log('Error getting my archive', error);
      }
    },
    setPinValidation(pinValidation: any) {
      this.pinValidation = pinValidation;
    },
    async validatePin({
      profile,
      pin,
    }: {
      profile: ProfileFragment;
      pin: string;
    }) {
      this.pinValidation = {
        validating: true,
        validPin: false,
        pin,
      };
      try {
        const result = await api.profiles.validateUserPin({
          pin: pin.toString(),
          profileId: profile.id,
          profileType: profile.type,
        });
        this.setPinValidation({
          validating: false,
          validPin: result.success,
          pin,
        });
      } catch (error) {
        console.log('Error validating pin', error);
        this.setPinValidation({
          validating: false,
          validPin: false,
        });
      }
    },
  },
});
